<template>
<!-- :breakpoints="{
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 2
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesPerGroup: 3
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30,
            slidesPerGroup: 4
        },
        }" -->
  <div class="container area-slides" v-if="data.length > 0">
    <swiper ref="slideExam"
      :slides-per-view="view"
      :slides-per-group="view"
      :breakpoints="breakpoints"
      :observeParents="true"
      :observer="true"
      :space-between="30"
      :loop="true"
      :pagination="true"
      :navigation="false"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(item,index) in data"
        :key="item.id"
      >
        <article class="card mb-2 card-exam">
            <img class="card-img-top"
                :src="item.image_path ? item.image_path : 'https://mocvien.com/anh-tin-tuc/69.webp'"
            >
            <div class="card-body">
                <div class="card-title">
                    <span class="pr-1">{{ item.category_name }}</span>
                </div>
                <p class="card-text card-name">{{ item.exam_name }}</p>
                <div class="row">
                    <div class="card-author col-7">{{ item.created_by }}</div>
                    <div class="text-right card-price__discount col-5"> {{ handleDiscount(item.price, item.discount) }} VND </div>
                </div>
                <div class="card-price"> {{ formatNumber(item.price) }} VND </div>
                <!-- <div class="row">
                    <button type="button" class="btn col card-button card-button__buy btn-secondary">Mua ngay </button>
                    <button type="button" disabled="disabled" class="btn col card-button card-button__add btn-secondary disabled">
                        <img src="https://img.icons8.com/windows/25/ffffff/shopping-cart-loaded--v1.png" style="border: none;">
                        Thêm vào giỏ
                    </button>
                </div> -->
                <div class="row" v-if="item.is_exam_paid === 0">
                    <b-button class="col card-button card-button__buy" @click="buyNow(item)">{{
                            $t("examStudent.button.buy")
                        }}
                    </b-button>
                    <b-button
                            class="col card-button card-button__add"
                            @click="addToCard(item.id)"
                                :disabled="item.price === 0"
                    >
                        <img style="border: none"
                                src="https://img.icons8.com/windows/25/ffffff/shopping-cart-loaded--v1.png"
                        />
                        {{ $t("examStudent.button.add") }}
                    </b-button>
                </div>
                <div v-if="item.is_exam_paid === 1" class="d-flex justify-content-center">
                    <b-button class="card-button card-button__own" @click="handleMyExam">{{
                            $t("examStudent.label.owner")
                        }}</b-button>
                </div>
            </div>
        </article>
      </swiper-slide>
    </swiper>
    <div @click="prev" class="swiper-button-prev" :class="{'swiper-button-disabled' : disablePrev}"></div>
    <div @click="next" class="swiper-button-next" :class="{'swiper-button-disabled' : disableNext}"></div>

  </div>

</template>

<script>
import { mapGetters } from "vuex";
import router         from "@/router";
import {notification} from "ant-design-vue";
import { Navigation, Pagination } from "swiper";

import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props:{
    view: Number,
     isType: {
        type: Boolean,
        default: true
     },
      breakpoints:{
        type: Object,
        default: () =>{}
    },
    data:{
        type: Array,
        default: () => [
                {
                    "id": 343,
                    "exam_id": 10,
                    "exam_name": "<초급1> 1과",
                    "category_id": 1,
                    "category_name": "<초급1>비상한국어",
                    "image_path": null,
                    "price": 20000,
                    "discount": 0,
                    "tags": "39",
                    "created_by": "superadmin",
                    "created_at": "2023-07-26 09:27:03",
                    "updated_at": "2023-07-26 09:27:03",
                    "is_exam_paid": 1
                },
                {
                    "id": 344,
                    "exam_id": 337,
                    "exam_name": "TOPIK II - ĐỀ THI THỬ SỐ 1 - ĐỀ VIẾT [2022] (토픽 II 모의고사 1회 쓰기)",
                    "category_id": 7,
                    "category_name": "TOPIK",
                    "image_path": null,
                    "price": 0,
                    "discount": 0,
                    "tags": "39",
                    "created_by": "superadmin",
                    "created_at": "2023-07-26 09:27:03",
                    "updated_at": "2023-07-26 09:27:03",
                    "is_exam_paid": 1
                },
                {
                    "id": 345,
                    "exam_id": 340,
                    "exam_name": "TOPIK II - ĐỀ THI THỬ SỐ 2 - ĐỀ VIẾT [2022] (토픽 II 모의고사 2회 쓰기)",
                    "category_id": 7,
                    "category_name": "TOPIK",
                    "image_path": null,
                    "price": 0,
                    "discount": 0,
                    "tags": "37",
                    "created_by": "superadmin",
                    "created_at": "2023-07-26 09:27:03",
                    "updated_at": "2023-07-26 09:27:03",
                    "is_exam_paid": 1
                },
                {
                    "id": 346,
                    "exam_id": 344,
                    "exam_name": "TOPIK II - ĐỀ THI THỬ SỐ 1 - FULL TEST [2022] (토픽 II 모의고사 1회 풀세트)",
                    "category_id": 7,
                    "category_name": "TOPIK",
                    "image_path": null,
                    "price": 0,
                    "discount": 0,
                    "tags": "39",
                    "created_by": "superadmin",
                    "created_at": "2023-07-26 09:27:03",
                    "updated_at": "2023-07-26 09:27:03",
                    "is_exam_paid": 1
                },
                {
                    "id": 347,
                    "exam_id": 345,
                    "exam_name": "TOPIK II - ĐỀ THI THỬ SỐ 2 - FULL TEST [2022] (토픽 II 모의고사 2회 풀세트)",
                    "category_id": 7,
                    "category_name": "TOPIK",
                    "image_path": null,
                    "price": 0,
                    "discount": 0,
                    "tags": "37",
                    "created_by": "superadmin",
                    "created_at": "2023-07-26 09:27:03",
                    "updated_at": "2023-07-26 09:27:03",
                    "is_exam_paid": 1
                }
            ]
    }
  },
  data() {
    return {
      swiper: null,
      disableNext: false,
      disablePrev: false,
    };
  },
  async created(){
    localStorage.removeItem("exam-selected");
  },
  computed:{
     ...mapGetters({

      user: "auth/user"
    }),
  },
  methods: {
    getImageUrl(imageId) {
      return `https://picsum.photos/600/400/?image=${imageId}`;
    },
    onSwiper(swiper) {

      this.swiper = swiper;
    },
    onSlideChange() {
     // this.swiper.isEnd === true ? this.disableNext = true : this.disableNext = false;
     // this.swiper.isBeginning === true ? this.disablePrev = true : this.disablePrev = false;
    },
    next(){
        this.swiper.slideNext();
      //  this.swiper.isEnd === true ? this.disableNext = true : this.disableNext = false;
      //  this.disablePrev = false;
    },
    prev(){

        this.swiper.slidePrev();
      //  this.disableNext = false;
      //  this.swiper.isBeginning === true ? this.disablePrev = true : this.disablePrev = false;
    },

     formatNumber(n){
        let x = Number(n)
        return (x).toLocaleString();
    },
    handleDiscount(a,b){
        let price = Number(a);
        let discount = Number(b);
        let price_after_discount =  price - ((price * discount)/100);
        return (price_after_discount).toLocaleString();
    },
    openNotification: function (type, message, description) {
        notification[type]({
            message: message,
            description: description,
            duration: 3,
        });
    },
    async addToCard(id) {
        this.isLoading=true;
        const params = {
            user_id: this.user.id,
            id: id
        };
        await this.$store.dispatch("exam/addToCard", params);
        const apiRes = this.$store.state.exam.examInCart.status ? this.$store.state.exam.examInCart.status : this.$store.state.exam.examInCart;
        if (apiRes !== 200) {
            apiRes === 402
                ? this.openNotification("error", this.$t('examStudent.toast.error'),  this.$t('examStudent.toast.cantAdd_noti'))
                : this.openNotification("error", this.$t('examStudent.toast.error'), this.$t('examStudent.toast.error_noti'));
        } else {
            this.openNotification("success", this.$t('examStudent.toast.successfully'), this.$t('examStudent.toast.successfully_noti'));
        }
        await this.$store.dispatch("exam/getExamInCart", this.user.id);
        this.isLoading=false;
    },
    async buyNow(exam) {
        if (!(exam.price - (exam.price * exam.discount) / 100)) {
                    const params = {
                        exam: JSON.stringify([exam.id]),
                    }
                    await this.$store.dispatch("exam/getTransferExam", params);
                    this.$success({
                        title: h => <div style="fontWeight: bold;color:green;">{this.$t("payment.message.transfer_confirmation")} </div>,
                        content: h => <div style="color:green;">{ this.$t("buyExam.label.please_wait_admin_confirm") }</div>,
                        cancelButtonProps: {
                            style: {display: "none"}
                        },
                        keyboard: false,
                        onOk() {
                           // router.push("/student/exam/my-exam");
                        }
                    });
                    return
        }
        await localStorage.setItem("exam-selected", JSON.stringify([exam]));
        router.push("/student/exam/buy-exam");
    },
    handleMyExam(){
        router.push("/student/exam/my-exam")
    },

  },
};
</script>

<style scoped>
.area-slides{
    border-radius: 50px;
    background: linear-gradient(180deg, #F1F4FF 0%, rgba(174, 185, 208, 0.00) 100%);
    padding: 30px 40px 0;
    position: relative;
}
.container {
  width: 100%;
  max-width: 100%;
  height: auto;
  overflow: hidden;
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow: inherit;
  padding-bottom: 30px;
}




.card-exam {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  border: none;
}

.card-exam img {
  border-radius: 10px 10px 0px 0px;
	border-top: 1px solid #e8e8e8;
	border-bottom: 1px solid #e8e8e8;
}

.card-title {
  font-weight: 700;
  font-size: 16px !important;
  line-height: 19px;
  color: #ffbf00;
  margin-bottom: 7px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.card-body {
  padding: 7px 12px 13px 12px;
}

.card-price__discount,
.card-text,
.card-author,
.card-price {
  font-size: 12px;
  line-height: 150%;
}

.card-author {
  color: #0770ab;
  padding: 0px;
}
.card-name {
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 20px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.card-price__discount {
  padding: 0px;
  font-weight: 700;
  color: #f61717;
}

.card-price {
  text-align: right;
  text-decoration: line-through;
  padding-bottom: 5px;
}

.card-button {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  border: none;
  padding: 6px 0px;
  text-align: center;
}
.card-button__buy {
    background-color: #35b560;
    margin-right: 11px;
}
.card-button__add {
    background-color: #ffbf00;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}
.card-button__buy:hover {
    background-color: #2a924e !important;
    color: white !important;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.card-button__add:hover:disabled {
    background-color: #6c757d !important;
    color: white !important;
}
.card-button__add:hover {
    background-color: #edb300 !important;
    color: white !important;
}

.card-button__own {
    background-color: #3182CE;
    padding: 9px 10px;
    width: 100%;
}
.card-button__own:hover {
    background-color: #3182CE !important;
    color: white !important;
    cursor: default;
}

</style>

<style>
.swiper-pagination-bullet{
    background: #ADC6FF;
    opacity: 1;
}
.swiper-pagination-bullet-active{
    width: 24px;
    border-radius: 4px;
    background: #485CC7;
}
.swiper-button-prev:after, .swiper-button-next:after{
    color: #808EB1;
    font-size: 27px;
    font-weight: bold;
}

</style>
